import { client } from "apollo/client";
import { gql } from "@apollo/client";

export const fetchFeatureFlags = async () => {
  const query = gql`
    query feature_flags {
      feature_flags
    }
  `;

  try {
    const { data, errors } = await client.query({
      query: query,
      fetchPolicy: "no-cache"
    });

    if (!errors) {
      return data.feature_flags;
    }

    return [];
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};
